export default "__VITE_ASSET__a45bbbea__"